module.exports = __webpack_public_path__ + "3cd36578026d6c12eddf9a5c671a251d.woff2";